// Froala Mentions Plugin
// This plugin adds mention functionality to Froala editor

// Wait for FroalaEditor to be available
function initializeMentionsPlugin() {
  if (typeof window.FroalaEditor === 'undefined') {
    console.warn('FroalaEditor not available, retrying in 100ms...');
    setTimeout(initializeMentionsPlugin, 100);
    return;
  }

  const FroalaEditor = window.FroalaEditor;
  // Add an option for the mentions plugin
  FroalaEditor.DEFAULTS = Object.assign(FroalaEditor.DEFAULTS, {
    mentions: {
      enabled: true,
      trigger: '@',
      items: [],
      minLength: 1,
      maxLength: 20,
      showOnMobile: true
    }
  });

  // Define the mentions plugin
  FroalaEditor.PLUGINS.mentions = function (editor) {
    // Private variables
    var mentionsContainer = null;
    var mentionsList = null;
    var isVisible = false;
    var currentQuery = '';
    var currentItems = [];
    var accountId = null;
    var currentMentionRange = null; // keeps track of the @query text range

    // Private methods
    function _init() {
      // Get account ID from the editor's container
      var container = editor.el.closest('[data-account-id]');
      if (container) {
        accountId = container.getAttribute('data-account-id');
      } else {
        // Try to get from URL
        var urlParts = window.location.pathname.split('/');
        if (urlParts.length > 1 && !isNaN(urlParts[1])) {
          accountId = urlParts[1];
        } else {
          // Try to get from any element with data-account-id
          var accountElement = document.querySelector('[data-account-id]');
          if (accountElement) {
            accountId = accountElement.getAttribute('data-account-id');
          }
        }
      }

      if (!accountId) {
        console.error('Could not find account ID for mentions plugin');
        return;
      }
      _createMentionsDropdown();
      _bindEvents();
    }

    function _createMentionsDropdown() {
      mentionsContainer = document.createElement('div');
      mentionsContainer.className = 'fr-mentions-dropdown';

      mentionsList = document.createElement('ul');
      mentionsList.style.cssText = `
        list-style: none;
        margin: 0;
        padding: 0;
      `;

      mentionsContainer.appendChild(mentionsList);
      document.body.appendChild(mentionsContainer);
    }

    function _bindEvents() {
      // run before Froala and use the return value to stop default behavior
      editor.events.on('keydown', function(e) {
        return _handleKeyDown(e);
      }, true);

      editor.events.on('input', _checkForMentions);

      editor.events.on('blur', function() {
        setTimeout(function() {
          if (!mentionsContainer.contains(document.activeElement)) {
            _hideDropdown();
          }
        }, 100);
      });

      document.addEventListener('click', function(e) {
        if (mentionsContainer && !mentionsContainer.contains(e.target) && !editor.el.contains(e.target)) {
          _hideDropdown();
        }
      });
    }

    function _checkForMentions() {
      // Try different ways to get the current text and cursor position
      var currentText = '';
      var cursorPosition = 0;
      
      // Method 1: Try to get from editor's HTML content
      try {
        var editorElement = editor.el;
        if (editorElement) {
          // For inline mode, we need to get the text content differently
          if (editor.opts.toolbarInline) {
            // Get cursor position using window.getSelection
            var selection = window.getSelection();
            if (selection && selection.rangeCount > 0) {
      var range = selection.getRangeAt(0);
              
              if (range.startContainer && range.startContainer.nodeType === Node.TEXT_NODE) {
                currentText = range.startContainer.textContent;
                cursorPosition = range.startOffset;
              }
            }
          } else {
            // For regular mode, try the selection API
            var selection = editor.selection.get();
            if (selection && selection.range) {
              var range = selection.range;
      var node = range.startContainer;
              
              if (node && node.nodeType === Node.TEXT_NODE) {
                currentText = node.textContent;
                cursorPosition = range.startOffset;
                              }
              } else {
                // Fallback: If not in a text node, try to insert at cursor position
                console.log('Not in text node (regular mode), using fallback method');
                var mentionNode = document.createElement('span');
                mentionNode.className = 'fr-mention';
                mentionNode.setAttribute('data-user-id', user.id);
                mentionNode.setAttribute('data-user-name', user.display_name);
                mentionNode.setAttribute('data-user-email', user.email);
                mentionNode.textContent = '@' + user.display_name;
                
                range.insertNode(mentionNode);
                range.setStartAfter(mentionNode);
                range.setEndAfter(mentionNode);
                editor.selection.set(range);
      }
            }
          }
        } catch (error) {
        console.error('Error getting text content:', error);
      }
      
      if (!currentText) {
        // Fallback: try to get text from the editor's HTML
        try {
          var html = editor.html.get();
          // Strip HTML tags to get text
          var tempDiv = document.createElement('div');
          tempDiv.innerHTML = html;
          currentText = tempDiv.textContent || tempDiv.innerText || '';
        } catch (error) {
          console.error('Error in fallback text extraction:', error);
        return;
      }
      }
      
      // Find @ symbol before cursor
      var triggerIndex = -1;
      if (currentText) {
        // Look for @ symbol before the cursor position
        var textBeforeCursor = currentText.substring(0, cursorPosition);
        triggerIndex = textBeforeCursor.lastIndexOf('@');
      }
      
      if (triggerIndex !== -1) {
        var query = currentText.substring(triggerIndex + 1, cursorPosition);

        // Show dropdown even for empty query (just @ symbol)
        if (query.length <= editor.opts.mentions.maxLength) {
          currentQuery = query;
      _fetchMentions(query);
        } else {
          _hideMentions();
        }
      } else {
        _hideMentions();
      }
    }

    function _fetchMentions(query) {
      if (!accountId) {
        console.error('Account ID not found for mentions in editor:', editor);
        return;
      }

      // Get CSRF token
      const csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content');

      fetch(`/${accountId}/mentions.json`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': csrfToken,
          'Accept': 'application/json'
        },
        credentials: 'same-origin'
      })
        .then(response => {
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }
          return response.json();
        })
        .then(users => {
          // Filter users based on query
          var filteredUsers = users.filter(user =>
            user.display_name.toLowerCase().includes(query.toLowerCase()) ||
            user.email.toLowerCase().includes(query.toLowerCase())
          );
          
          // Get current editor content to check for existing mentions
          var currentHtml = editor.html.get();
          
          // Filter out users who are already mentioned
          var usersNotMentioned = filteredUsers.filter(user => {
            // Check if this user is already mentioned in the editor
            var mentionPattern = new RegExp(`data-user-id="${user.id}"`, 'i');
            return !mentionPattern.test(currentHtml);
          });
          
          // Remove duplicates based on user ID using a Map for better performance
          const uniqueUsersMap = new Map();
          usersNotMentioned.forEach(user => {
            if (!uniqueUsersMap.has(user.id)) {
              uniqueUsersMap.set(user.id, user);
            }
          });
          currentItems = Array.from(uniqueUsersMap.values());
          if (currentItems.length > 0) {
            _showMentions();
          } else {
            _hideMentions();
          }
        })
        .catch(error => {
          console.error('Error fetching mentions for editor:', editor, 'error:', error);
          _hideMentions();
        });
    }

    function _showMentions() {
      if (!mentionsContainer) {
        _createMentionsDropdown();
      }
      
      // Clear previous content
      mentionsList.innerHTML = '';
      if (currentItems.length > 0) {
        currentItems.forEach((user, index) => {
          var item = document.createElement('div');
          item.className = 'mention-item';
          item.setAttribute('data-user-id', user.id);
          item.setAttribute('data-user-name', user.display_name);
          item.setAttribute('data-user-email', user.email);
          
          var avatar = document.createElement('div');
          avatar.className = 'mention-avatar';
          avatar.textContent = user.display_name.charAt(0).toUpperCase();
          
          var info = document.createElement('div');
          info.className = 'mention-info';
          
          var name = document.createElement('div');
          name.className = 'mention-name';
          name.textContent = user.display_name;
          
          var email = document.createElement('div');
          email.className = 'mention-email';
          email.textContent = user.email;
          
          info.appendChild(name);
          info.appendChild(email);
          
          item.appendChild(avatar);
          item.appendChild(info);
          
          // prevent editor blur
          item.addEventListener('mousedown', function(e) { e.preventDefault(); });

          item.addEventListener('click', function(e) {
            e.preventDefault();
            _selectMention(item);
          });
          
          mentionsList.appendChild(item);
        });
        
        _positionDropdown();
        _showDropdown();
      } else {
        _hideDropdown();
      }
    }

    function _positionDropdown() {
      var rect = null;
      
      // Try to get cursor position for inline mode
      if (editor.opts.toolbarInline) {
        var selection = window.getSelection();
        if (selection && selection.rangeCount > 0) {
          var range = selection.getRangeAt(0);
          rect = range.getBoundingClientRect();
        }
      } else {
        // For regular mode, try the editor's selection API
        var selection = editor.selection.get();
        if (selection && selection.range) {
          var range = selection.range;
          rect = range.getBoundingClientRect();
        }
      }
      
      if (rect) {
        // Position dropdown at the cursor position
        mentionsContainer.style.left = rect.left + 'px';
        
        // Always position below the cursor with a small gap
        var topPosition = rect.bottom + 5;
        
        // Check if there's enough space below, if not position above
        var dropdownHeight = mentionsContainer.offsetHeight || 200; // Default height
        var windowHeight = window.innerHeight;
        var spaceBelow = windowHeight - (topPosition + dropdownHeight);
        
        if (spaceBelow < 10) {
          // Not enough space below, position above the cursor
          topPosition = rect.top - dropdownHeight - 5;
          
          // If still not enough space above, position at the top of viewport
          if (topPosition < 10) {
            topPosition = 10;
          }
        }
        
        mentionsContainer.style.top = topPosition + 'px';
        
      } else {
        console.log('Could not position dropdown - no rect available');
      }
    }

    function _hideMentions() {
      console.log('Success');
    }

    function _selectMention(item) {
      console.log('Selecting mention:', item);
      var userId = item.getAttribute('data-user-id');
      var userName = item.getAttribute('data-user-name');
      var userEmail = item.getAttribute('data-user-email');
      
      console.log('User data:', { id: userId, name: userName, email: userEmail });
      
      var user = {
        id: userId,
        display_name: userName,
        email: userEmail
      };
      
      _insertMention(user);
    }

    // helper: find deepest text node inside a node (used to find where to insert)
    function _getDeepestTextNode(node) {
      if (!node) return null;
      if (node.nodeType === Node.TEXT_NODE) return node;
      // try lastChild descent (so we find the text node closest to the caret position)
      var cur = node;
      while (cur && cur.nodeType !== Node.TEXT_NODE) {
        if (cur.lastChild) cur = cur.lastChild;
        else break;
      }
      if (cur && cur.nodeType === Node.TEXT_NODE) return cur;
      // fallback: tree walker to find first text node
      var walker = document.createTreeWalker(node, NodeFilter.SHOW_TEXT, null, false);
      return walker.nextNode();
    }

    // compute mention range from current selection (node, start, end)
    function _getMentionRangeFromSelection() {
      var sel = window.getSelection();
      if (!sel || !sel.rangeCount) return null;
      var selRange = sel.getRangeAt(0);
      var node = selRange.startContainer;
      var offset = selRange.startOffset;

      // if the startContainer is not a text node, attempt to find a nearby text node
      if (node.nodeType !== Node.TEXT_NODE) {
        // If cursor is inside an element with children, try the node just before the caret
        if (node.childNodes && offset > 0) {
          var before = node.childNodes[offset - 1];
          var textNode = _getDeepestTextNode(before);
          if (textNode) {
            node = textNode;
            offset = textNode.textContent ? textNode.textContent.length : 0;
          }
        }

        // fallback: try previousSibling chain
        if (node.nodeType !== Node.TEXT_NODE) {
          var prev = node.previousSibling;
          while (prev && prev.nodeType !== Node.TEXT_NODE) {
            prev = (prev.lastChild) ? _getDeepestTextNode(prev) : prev.previousSibling;
          }
          if (prev && prev.nodeType === Node.TEXT_NODE) {
            node = prev;
            offset = node.textContent.length;
          } else {
            // Cannot find a sensible text node near caret
            return null;
          }
        }
      }

      // now node is text node, offset is caret offset inside it
      var text = node.textContent || '';
      var atIndex = text.lastIndexOf('@', Math.max(0, offset - 1));
      if (atIndex === -1) return null;

      return { node: node, start: atIndex, end: offset };
    }

    function _insertMention(user) {
      console.log('Inserting mention for user:', user);
      try {
        // if stored range missing or disconnected, attempt to recompute from selection
        if (!currentMentionRange || !currentMentionRange.node || !currentMentionRange.node.isConnected) {
          var recomputed = _getMentionRangeFromSelection();
          if (!recomputed) {
            console.warn('No mention range available (nothing inserted).');
            return;
          }
          currentMentionRange = recomputed;
          console.log('Recomputed mention range from selection:', currentMentionRange);
        }

        var node = currentMentionRange.node;
        var start = currentMentionRange.start;
        var end = currentMentionRange.end;
        var originalText = node.textContent || '';

        // Guard: make sure start/end are in-bounds
        if (start < 0 || start > originalText.length || end < start || end > originalText.length) {
          console.warn('Mention range out of bounds, recomputing...');
          var recomputed = _getMentionRangeFromSelection();
          if (!recomputed) {
            console.warn('Recompute failed, aborting insert.');
            return;
          }
          currentMentionRange = recomputed;
        }

        // Remove the @query from the text node
        var before = originalText.substring(0, start);
        var after = originalText.substring(end);
        node.textContent = before + after;

        // Create mention span
        var mentionNode = document.createElement('span');
        mentionNode.className = 'fr-mention';
        mentionNode.setAttribute('data-user-id', user.id);
        mentionNode.setAttribute('data-user-name', user.display_name);
        mentionNode.setAttribute('data-user-email', user.email);
        mentionNode.textContent = '@' + user.display_name;

        // Create a range at the insertion point (start index inside modified text node)
        var range = document.createRange();
        // ensure start index is not beyond the new node length
        var insertIndex = Math.min(before.length, node.textContent.length);
        range.setStart(node, insertIndex);
        range.collapse(true);

        // Insert mentionNode
        range.insertNode(mentionNode);

        // Insert a single space after the mention
        var space = document.createTextNode(' ');
        if (mentionNode.parentNode) {
          mentionNode.parentNode.insertBefore(space, mentionNode.nextSibling);
        }

        // Place caret after the space
        var sel = window.getSelection();
        var afterRange = document.createRange();
        afterRange.setStartAfter(space);
        afterRange.collapse(true);
        sel.removeAllRanges();
        sel.addRange(afterRange);

        // Focus Froala editor (safe)
        try { editor.events.trigger('focus'); } catch (e) { /* ignore */ }

        // Clear tracker
        currentMentionRange = null;

        // hide dropdown
        setTimeout(() => { _hideDropdown(); }, 50);

        console.log('Mention inserted successfully for', user.display_name);
      } catch (err) {
        console.error('Error inserting mention:', err);
      }
    }

    function _handleKeyDown(e) {
      console.log('keydown', e.key);
      
      // Handle backspace when cursor is inside a mention element
      if (e.key === 'Backspace') {
        var selection = window.getSelection();
        if (selection && selection.rangeCount > 0) {
          var range = selection.getRangeAt(0);
          var startContainer = range.startContainer;
          
          // Check if cursor is inside a mention element
          var mentionElement = startContainer.closest ? startContainer.closest('.fr-mention') : null;
          if (!mentionElement && startContainer.parentNode) {
            mentionElement = startContainer.parentNode.closest ? startContainer.parentNode.closest('.fr-mention') : null;
          }
          
          // Also check if the cursor is right after a mention element
          if (!mentionElement) {
            var previousSibling = startContainer.previousSibling;
            if (previousSibling && previousSibling.classList && previousSibling.classList.contains('fr-mention')) {
              mentionElement = previousSibling;
            }
          }
          
          if (mentionElement) {
            console.log('Backspace detected on mention, deleting entire mention');
            e.preventDefault();
            e.stopPropagation();
            
            // Delete the entire mention element
            mentionElement.remove();
            
            // Ensure editor content is updated
            editor.events.trigger('contentChanged');
            return false;
          }
        }
      }
      
      // Handle dropdown navigation only when dropdown is visible
      if (!mentionsContainer || mentionsContainer.style.display === 'none') return;
      var items = mentionsContainer.querySelectorAll('.mention-item');
      if (!items.length) return;

      var currentIndex = -1;
      for (var i = 0; i < items.length; i++) {
        if (items[i].classList.contains('selected')) { currentIndex = i; break; }
      }

      switch (e.key) {
        case 'ArrowDown':
          e.preventDefault(); e.stopPropagation();
          if (currentIndex >= 0) items[currentIndex].classList.remove('selected');
          (items[currentIndex + 1] || items[0]).classList.add('selected');
          (items[currentIndex + 1] || items[0]).scrollIntoView({ block: 'nearest' });
          return false; // important

        case 'ArrowUp':
          e.preventDefault(); e.stopPropagation();
          if (currentIndex >= 0) items[currentIndex].classList.remove('selected');
          var upIndex = currentIndex > 0 ? currentIndex - 1 : items.length - 1;
          items[upIndex].classList.add('selected');
          items[upIndex].scrollIntoView({ block: 'nearest' });
          return false; // important

        case 'Enter':
          e.preventDefault(); e.stopPropagation();
          var selected = mentionsContainer.querySelector('.mention-item.selected') || mentionsContainer.querySelector('.mention-item');
          if (selected) {
            _selectMention(selected);
          } else {
            console.warn('Enter pressed but no selected mention item found');
          }
          return false; // stops Froala from inserting a newline

        case 'Escape':
          e.preventDefault(); e.stopPropagation();
          _hideDropdown();
          return false;
      }
    }

    function _showDropdown() {
      if (mentionsContainer) {
        mentionsContainer.style.display = 'block';
        isVisible = true;
        var items = mentionsContainer.querySelectorAll('.mention-item');
        items.forEach(function(item) {
          item.classList.remove('selected');
        });
        
        // Select the first item by default
        if (items.length > 0) {
          items[0].classList.add('selected');
        }
      }
    }
    
    function _hideDropdown() {
      if (mentionsContainer) {
        mentionsContainer.style.display = 'none';
        isVisible = false;
        var items = mentionsContainer.querySelectorAll('.mention-item');
        items.forEach(function(item) {
          item.classList.remove('selected');
        });
      }
    }

    // Public methods
    return {
      _init: _init
    };
  };
}

// Start initialization when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeMentionsPlugin);
} else {
  initializeMentionsPlugin();
}
